import React from "react";
import PageLayout from "./PageLayout";

export default function LegalPage({ doc }) {
  return (
    <PageLayout title={doc.title} subtitle={null}>
      <div className="max-w-3xl mx-auto px-5 py-14 md:py-20">
        <p className="font-serif-body text-[13px] text-[#999] italic mb-8">
          {doc.updated}
        </p>
        <p className="font-serif-body text-[#444] text-[16px] leading-[1.9] mb-10">
          {doc.intro}
        </p>

        <div className="space-y-9">
          {doc.sections.map((s) => (
            <div key={s.heading}>
              <h2 className="font-serif-display text-[#0f9fbc] text-lg md:text-xl font-bold mb-2">
                {s.heading}
              </h2>
              <p className="font-serif-body text-[#555] text-[15px] leading-[1.9]">
                {s.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </PageLayout>
  );
}
